/* ════════════════════════════════════════════════════════════════════════
   OBRIY — collection listing: native Shopify filtering · sort · grid/list
   Shopify filters and paginates the shelf on the server. This script only
   controls presentation, leaving filter URLs and pagination URLs intact.
   ════════════════════════════════════════════════════════════════════════ */
(function () {
  function num(el, key) {
    return parseFloat(el.dataset[key]) || 0;
  }

  function init(root) {
    if (!root || root.dataset.lpReady === "1") return;
    root.dataset.lpReady = "1";

    var grid = root.querySelector("[data-lp-grid]");
    var list = root.querySelector("[data-lp-list]");
    var compareBody = root.querySelector("[data-lp-compare-body]");
    var filterToggle = root.querySelector("[data-filter-toggle]");
    var filterPanel = root.querySelector("[data-filter-panel]");
    var sortSel = root.querySelector("[data-lp-sort]");
    var containers = [grid, list, compareBody];
    var hasProducts = grid && grid.querySelector("[data-lp-item]");

    var state = {
      sort: sortSel ? sortSel.value : "lot-desc",
      view: list && !list.hasAttribute("hidden") ? "list" : "grid",
    };

    function loadCollection(url, pushState) {
      var pageUrl = new URL(url, window.location.origin);
      var sectionUrl = new URL(pageUrl);
      var sectionId = root.dataset.sectionId;

      if (!sectionId || !window.fetch) {
        window.location.assign(pageUrl.href);
        return;
      }

      sectionUrl.searchParams.set("section_id", sectionId);
      root.classList.add("is-loading");
      root.setAttribute("aria-busy", "true");

      fetch(sectionUrl.href, { headers: { "X-Requested-With": "XMLHttpRequest" } })
        .then(function (response) {
          if (!response.ok) throw new Error("Unable to update collection");
          return response.text();
        })
        .then(function (html) {
          var documentFragment = new DOMParser().parseFromString(html, "text/html");
          var nextRoot = documentFragment.querySelector("[data-collection]");

          if (!nextRoot) throw new Error("Collection section was not returned");

          var nextToggle = nextRoot.querySelector("[data-filter-toggle]");
          var nextPanel = nextRoot.querySelector("[data-filter-panel]");
          if (nextToggle && nextPanel) {
            nextToggle.setAttribute("aria-expanded", "true");
            nextPanel.classList.add("is-open");
          }

          nextRoot.classList.add("is-filtering");
          root.replaceWith(nextRoot);
          if (pushState) window.history.pushState({}, "", pageUrl.href);
          init(nextRoot);
          window.setTimeout(function () {
            nextRoot.classList.remove("is-filtering");
          }, 460);
        })
        .catch(function () {
          window.location.assign(pageUrl.href);
        });
    }

    function setFilterPanel(open) {
      if (!filterToggle || !filterPanel) return;
      filterToggle.setAttribute("aria-expanded", open ? "true" : "false");
      filterPanel.classList.toggle("is-open", open);
    }

    function syncFilterStates() {
      var params = new URLSearchParams(window.location.search);
      var brewMethod = params.get("filter.v.m.custom.brew_methods") || "";
      var availability = params.get("filter.v.availability");

      root.querySelectorAll("[data-brew-method]").forEach(function (link) {
        link.classList.toggle("is-on", link.getAttribute("data-brew-method") === brewMethod);
      });

      if (availability !== null) {
        root.querySelectorAll("[data-availability-value]").forEach(function (link) {
          link.classList.toggle(
            "is-on",
            link.getAttribute("data-availability-value") === availability
          );
        });
      }
    }

    function migrateLegacyBrewMethodUrl() {
      var pageUrl = new URL(window.location.href);
      var legacyMethod = pageUrl.searchParams.get("filter.p.m.custom.brew_methods");
      if (!legacyMethod) return false;

      pageUrl.searchParams.delete("filter.p.m.custom.brew_methods");
      pageUrl.searchParams.set("filter.v.m.custom.brew_methods", legacyMethod);
      loadCollection(pageUrl.href, true);
      return true;
    }

    function compare(a, b) {
      switch (state.sort) {
        case "price-asc":
          return num(a, "price") - num(b, "price");
        case "price-desc":
          return num(b, "price") - num(a, "price");
        case "name-asc":
          return (a.dataset.name || "").localeCompare(b.dataset.name || "");
        case "body-desc":
          return num(b, "body") - num(a, "body");
        default:
          return num(b, "lot") - num(a, "lot");
      }
    }

    function sortContainer(container) {
      if (!container) return;
      var items = Array.prototype.slice.call(container.querySelectorAll("[data-lp-item]"));
      items.sort(compare);
      items.forEach(function (item) {
        container.appendChild(item);
      });
    }

    function apply(animateItems) {
      containers.forEach(sortContainer);

      if (grid) grid.hidden = !hasProducts || state.view !== "grid";
      if (list) list.hidden = !hasProducts || state.view !== "list";

      if (animateItems && window.matchMedia("(prefers-reduced-motion: no-preference)").matches) {
        window.clearTimeout(root.filterAnimationTimer);
        root.classList.remove("is-filtering");
        void root.offsetWidth;
        root.classList.add("is-filtering");
        root.filterAnimationTimer = window.setTimeout(function () {
          root.classList.remove("is-filtering");
        }, 460);
      }
    }

    root.addEventListener("click", function (event) {
      if (event.target.closest("[data-filter-toggle]")) {
        setFilterPanel(filterToggle.getAttribute("aria-expanded") !== "true");
        return;
      }

      var filterLink = event.target.closest("[data-filter-panel] a");
      if (filterLink && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey) {
        event.preventDefault();

        var availabilityValue = filterLink.getAttribute("data-availability-value");
        if (availabilityValue !== null) {
          var availabilityUrl = new URL(window.location.href);
          availabilityUrl.searchParams.delete("filter.v.availability");
          availabilityUrl.searchParams.delete("page");
          if (filterLink.getAttribute("data-availability-active") !== "true") {
            availabilityUrl.searchParams.set("filter.v.availability", availabilityValue);
          }
          loadCollection(availabilityUrl.href, true);
          return;
        }

        var brewMethod = filterLink.getAttribute("data-brew-method");
        if (brewMethod !== null) {
          var brewMethodUrl = new URL(window.location.href);
          brewMethodUrl.searchParams.delete("filter.v.m.custom.brew_methods");
          brewMethodUrl.searchParams.delete("page");
          if (brewMethod !== "") {
            brewMethodUrl.searchParams.set("filter.v.m.custom.brew_methods", brewMethod);
          }
          loadCollection(brewMethodUrl.href, true);
          return;
        }

        loadCollection(filterLink.href, true);
        return;
      }

      var paginationLink = event.target.closest(".lp-pagination a");
      if (paginationLink && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey) {
        event.preventDefault();
        loadCollection(paginationLink.href, true);
        return;
      }

      var view = event.target.closest("[data-view]");
      if (view) {
        state.view = view.dataset.view;
        root.querySelectorAll("[data-view]").forEach(function (button) {
          button.classList.toggle("is-on", button === view);
        });
        apply(true);
      }
    });

    root.addEventListener("change", function (event) {
      if (event.target.closest("[data-lp-sort]")) {
        state.sort = event.target.value;
        apply(true);
      }
    });

    root.addEventListener("submit", function (event) {
      var form = event.target.closest(".lp-filter-price");
      if (!form) return;

      event.preventDefault();
      var formUrl = new URL(form.action, window.location.origin);
      var formData = new FormData(form);
      formData.forEach(function (value, name) {
        if (value !== "") formUrl.searchParams.append(name, value);
      });
      loadCollection(formUrl.href, true);
    });

    if (!migrateLegacyBrewMethodUrl()) {
      apply();
      syncFilterStates();
    }
  }

  function boot() {
    document.querySelectorAll("[data-collection]").forEach(init);
  }

  document.addEventListener("DOMContentLoaded", boot);
  document.addEventListener("shopify:section:load", function (event) {
    var root = event.target.querySelector("[data-collection]");
    if (root) {
      root.dataset.lpReady = "";
      init(root);
    }
  });
})();
